/**
* @adobe/react-spectrum-ui (c) by Adobe
* 
* @adobe/react-spectrum-ui is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpMedium = HelpMedium;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function HelpMedium(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      props = _objectWithoutProperties(_ref, ["scale"]);

  return _react["default"].createElement("svg", _extends({}, props, props), scale === 'L' && _react["default"].createElement("path", {
    d: "M11 2a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm-.007 14.681a1.145 1.145 0 0 1-1.227-1.215 1.159 1.159 0 0 1 1.115-1.201q.056-.002.112.001a1.159 1.159 0 0 1 1.226 1.088q.003.056.001.112a1.127 1.127 0 0 1-1.227 1.215zm1.981-6.63c-.684.642-1.344 1.215-1.333 1.736a2.275 2.275 0 0 0 .176.732.25.25 0 0 1-.232.343h-1.26a.3.3 0 0 1-.228-.069 1.886 1.886 0 0 1-.421-1.2c0-.816.508-1.336 1.35-2.17.578-.573.911-.937.911-1.475 0-.625-.421-1.059-1.49-1.059a5.337 5.337 0 0 0-2 .473.249.249 0 0 1-.347-.23v-1.24a.5.5 0 0 1 .3-.459 6.413 6.413 0 0 1 2.434-.5c2.1.006 3.261 1.2 3.261 2.725a3.053 3.053 0 0 1-1.121 2.393z"
  }), scale === 'M' && _react["default"].createElement("path", {
    d: "M9 1a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm1.3 12.3a1.222 1.222 0 0 1-.3.9 1.223 1.223 0 0 1-.9.3 1.2 1.2 0 0 1 0-2.4c.8 0 1.3.5 1.2 1.2zm.1-4.5c-.4.4-.8.8-.8 1.2a1.135 1.135 0 0 0 .3.8v.1a.098.098 0 0 1-.096.1H8.4a.229.229 0 0 1-.2-.1 1.666 1.666 0 0 1-.4-1.1 2.772 2.772 0 0 1 1-1.7 2.772 2.772 0 0 0 1-1.7c0-.5-.4-1.1-1.4-1.1a5.018 5.018 0 0 0-2 .4h-.2V4.3c0-.1 0-.2.1-.2a6.183 6.183 0 0 1 2.4-.5c1.9 0 3.1 1.1 3.1 2.7a3.704 3.704 0 0 1-1.4 2.5z"
  }));
}

HelpMedium.displayName = 'HelpMedium';